export const rules = {
    phone: /^[\+]?[(]?[0-9]{3}[)]?[-\s\.]?[0-9]{3}[-\s\.]?[0-9]{4,6}$/im
}
  
export const isValid = (example, regx) => regx.test(example)
  